import { useState, useEffect } from "react";
import type { RestaurantFormData } from "../../restaurant.types";

interface BudgetProps {
  formData: RestaurantFormData;
  updateFormData: (updatedFields: Partial<RestaurantFormData>) => void;
}

const Budget: React.FC<BudgetProps> = ({ formData, updateFormData }) => {
  const [localPriceRange, setLocalPriceRange] = useState({
    min: formData?.priceRange?.min ?? 1000,
    max: formData?.priceRange?.max ?? 20000,
  });

  /** Sync local state when formData changes externally */
  useEffect(() => {
    setLocalPriceRange({
      min: formData?.priceRange?.min ?? 1000,
      max: formData?.priceRange?.max ?? 20000,
    });
  }, [formData.priceRange?.min, formData.priceRange?.max]);

  
    useEffect(() => {
    const timeout = setTimeout(() => {
        updateFormData({
        priceRange: {
            min: localPriceRange.min,
            max: localPriceRange.max,
        },
        });
    }, 300);

    return () => clearTimeout(timeout);
    }, [localPriceRange]);

  /** Handle number input & maintain valid min/max range */
  const handlePriceChange = (field: "min" | "max", value: string) => {
    const numValue = parseInt(value.replace(/[^\d]/g, "")) || 0;

    setLocalPriceRange((prev) => {
      let min = field === "min" ? numValue : prev.min;
      let max = field === "max" ? numValue : prev.max;

      // auto-adjust so min <= max
      if (min > max) max = min;
      if (max < min) min = max;

      return { min, max };
    });
  };

  const formatNumber = (num: number) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Average Price & Budget Range
        </h3>

        <div className="bg-white rounded-lg border border-[#FFDDA6] p-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-1">
                Starting Price
              </label>
              <div className="relative w-full border border-[#FFDDA6] rounded-lg">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5E503F] text-sm">
                  KSH:
                </span>
                <input
                  type="text"
                  value={formatNumber(localPriceRange.min)}
                  onChange={(e) => handlePriceChange("min", e.target.value)}
                  className="w-full pl-12 pr-3 py-2 text-sm"
                  placeholder="1,000"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-[#111827] mb-1">
                Maximum Price
              </label>
              <div className="relative w-full border border-[#FFDDA6] rounded-lg">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5E503F] text-sm">
                  KSH:
                </span>
                <input
                  type="text"
                  value={formatNumber(localPriceRange.max)}
                  onChange={(e) => handlePriceChange("max", e.target.value)}
                  className="w-full pl-12 pr-3 py-2 text-sm"
                  placeholder="20,000"
                />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Budget;
